module.exports = __webpack_public_path__ + "static/poster-14ba44ce296f75c01a5cccd5f3d15951.jpg";